import flex from "@/utils/flex";
import styled from "styled-components";
import { storage } from "@/shared/firbase";
import { useState } from "react";
import { getDownloadURL, ref, uploadBytes } from "@firebase/storage";
import { db } from "@/shared/firbase";
import { collection, addDoc } from "firebase/firestore";
import Header from "@/components/Header/Index";

const Index = () => {
  const [title, setTitle] = useState("");
  const [folder, setFolder] = useState("");
  const [url, setUrl] = useState("");

  const onClickHandler = async () => {
    // 파이어베이스에서 blob이라는 형태의 데이터를 원해서 바꿔줌. 사진저장할려면.
    const blob = await fetch(url).then((r) => r.blob());

    // 만약에 blob의 타입이 이미지가 아니면 진행불가
    if (blob.type === "text/html")
      return alert("사용할 수 없는 사진입니다. 사진을 바꾸세요.");

    alert("사진 등록 중(완료라고 나올때까지 기다립시다.)");

    // 사진을 다운가능한 링크로 변경해서 파이어베이스 스토리지(저장소)에 저장.
    const upload_file = await uploadBytes(
      ref(storage, `${folder}/${title}.png`),
      blob
    );

    //  내가 저장할 데이터베이스 생성 혹은 가져오기
    const dbCollection = collection(db, `${folder}`);

    // 파이어베이스에 저장된 사진을 다운받을수 있는 url 생성
    const file_url = await getDownloadURL(upload_file.ref);

    // DB에 저장 addDoc(db이름,{저장할 방법})
    await addDoc(dbCollection, { name: `${title}`, url: file_url });
    alert("사진 등록 완료");
  };
  return (
    <>
      <Header />
      <CenterFlex>
        <Box>
          <input
            type="text"
            placeholder="URL - 구글에서 걍가져오기"
            onChange={(e) => {
              setUrl(e.target.value);
            }}
          />
          <input
            type="text"
            placeholder="사진이름- 한글만사용"
            onChange={(e) => {
              setTitle(e.target.value);
            }}
          />
          <input
            type="text"
            placeholder="폴더이름 - 월드컵끼리 같은폴더"
            onChange={(e) => {
              setFolder(e.target.value);
            }}
          />
          <button onClick={onClickHandler}>보내기</button>
        </Box>
      </CenterFlex>
    </>
  );
};

export default Index;

const CenterFlex = styled.div`
  ${flex({})};
  height: 90vh;
`;

const Box = styled.div`
  ${flex({ direction: "column" })};
  width: 600px;
  height: 600px;
  background-color: #eceaea;
  input {
    margin: 10px;
    width: 300px;
    height: 50px;
    font-size: 2rem;
    ::placeholder {
      font-size: 1.1rem;
    }
  }
`;
